export const PASSWORD_RESET_SOURCE_PARAM = "source";
export const WELCOME_EMAIL_PASSWORD_RESET_SOURCE = "welcome_email";
// Resend deadlines are kept per email, keyed the way the API keys its throttle:
// trimmed and lowercased, so "A@x.com " and "a@x.com" share one wait.
export const normalizeResetEmail = (email: string) =>
  email.trim().toLowerCase();

export const WELCOME_EMAIL_PASSWORD_RESET_QUERY = `${PASSWORD_RESET_SOURCE_PARAM}=${WELCOME_EMAIL_PASSWORD_RESET_SOURCE}`;
